import React, { FC } from 'react';

import { useModals } from '@contexts/common/ModalContext';

import RedeemModal from '@modules/modals/bonds/RedeemModal';
import WrongNetworkModal from '@modules/modals/common/WrongNetworkModal';

import { MODAL_TYPES } from '@constants/common/modals.constants';

import { RedeemModalProps } from '@app-types/common/modal.types';

const Modals: FC = () => {
  const { state } = useModals();

  return (
    <>
      {state.current === MODAL_TYPES.WRONG_NETWORK_MODAL && (
        <WrongNetworkModal />
      )}
      {state.current === MODAL_TYPES.BONDS_REDEEM_MODAL && (
        <RedeemModal {...(state.props as RedeemModalProps)} />
      )}
    </>
  );
};

export default Modals;
